import type { TreeFolder } from "@/domains/documents/types";

export function findFolderInTree(folders: TreeFolder[], id: string): TreeFolder | null {
  for (const folder of folders) {
    if (folder.id === id) return folder;
    const found = findFolderInTree(folder.children, id);
    if (found) return found;
  }
  return null;
}

/** Ids from the top of the tree down to `id`, inclusive; empty when absent. */
export function folderIdTrail(folders: TreeFolder[], id: string): string[] {
  for (const folder of folders) {
    if (folder.id === id) return [folder.id];
    const below = folderIdTrail(folder.children, id);
    if (below.length > 0) return [folder.id, ...below];
  }
  return [];
}
